/* ---- mobile menu ------------------------------------------------------- */
/* Phone-only slide-out. Same open/close language as the Quick Shop drawer:
   scrim click, Escape, and focus handed to the close button. */
(function(){
  var panel = document.getElementById('bb-menu');
  var burger = document.querySelector('[data-bb-menu]');
  if(!panel || !burger) return;
  var last = null;

  function open(){
    last = document.activeElement;
    panel.hidden = false;
    document.body.style.overflow = 'hidden';
    burger.setAttribute('aria-expanded','true');
    requestAnimationFrame(function(){ panel.classList.add('is-open'); });
    var c = panel.querySelector('.mnav__close');
    setTimeout(function(){ if(c) c.focus(); }, 60);
  }
  function close(){
    panel.classList.remove('is-open');
    document.body.style.overflow = '';
    burger.setAttribute('aria-expanded','false');
    setTimeout(function(){ panel.hidden = true; }, 300);
    if(last && last.focus) last.focus();
  }

  burger.onclick = open;
  [].forEach.call(panel.querySelectorAll('[data-bb-menu-close]'), function(e){ e.onclick = close; });
  document.addEventListener('keydown', function(e){
    if(!panel.hidden && e.key === 'Escape') close();
  });
  /* Back on a wide screen the desktop row is visible again — don't leave the
     panel open and the page locked. */
  window.addEventListener('resize', function(){
    if(!panel.hidden && window.innerWidth > 768) close();
  });
})();
